import { Link } from "wouter";
import TelecomFeatures from "../components/services/TelecomFeatures.jsx";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

const Services = () => {
  const [activeTab, setActiveTab] = useState('all');
  
  return (
    <>
    <Helmet>
  <title>Device Repair Services in North York | Phone, Laptop & Console Repair</title>
  <meta 
    name="description" 
    content="ZiwaTech offers phone, computer, tablet & game console repair in North York. Fast, affordable same-day service at Yorkgate Mall." 
  />
</Helmet>
      {/* Hero Section */}
      <div className="relative h-[500px] bg-cover bg-center bg-no-repeat" 
           style={{backgroundImage: "url('/images/hero-bg.webp')"}}>
        <div className="absolute inset-0 bg-black/50 flex items-center">
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Text Column */}
            <div className="text-white px-4">
             <h1 className="text-3xl md:text-4xl font-bold mb-4">
  Device Repair Services in North York (Yorkgate Mall)
</h1>
              <p className="text-xl md:text-lg max-w-xl mx-auto mb-8 drop-shadow-md">
                At ZiwaTech, we offer professional phone, computer, tablet, and game console repair services in North York. Our expert technicians provide fast, affordable, and same-day repairs for all major brands.
              </p>
              <div className="flex space-x-4">
                <a href="/contact" className="btn btn-primary px-6 py-3 rounded-full">
                  Book Repair
                </a>
                <a href="/services" className="btn btn-outline px-6 py-3 rounded-full">
                  Learn More
                </a>
              </div>
            </div>
    
            {/* Image/Feature Column */}
            <div className="hidden md:flex justify-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 max-w-md">
                <div className="grid grid-cols-2 gap-4">
                  <Link href="/services/phone-repair" className="text-center">
                    <i className="fas fa-mobile-alt text-4xl text-white mb-2"></i>
                    <p className="text-white">Phone Repair</p>
                  </Link>
                  <Link href="/services/computer-repair" className="text-center">
                    <i className="fas fa-laptop text-4xl text-white mb-2"></i>
                    <p className="text-white">Computer Repair</p>
                  </Link>
                  <Link href="/services/tablet-repair" className="text-center">
                    <i className="fas fa-tablet-alt text-4xl text-white mb-2"></i>
                    <p className="text-white">Tablet Repair</p>
                  </Link>
                  <Link href="/services/game-console-repair" className="text-center">
                    <i className="fas fa-gamepad text-4xl text-[#31b575] mb-2"></i>
                    <p className="text-[#31b575]">Console Repair</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Overview Section */}
      <div className="py-16 bg-neutral">
        <div className="container mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Our Comprehensive Repair Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">From smartphones to game consoles, we provide expert repair solutions for all your devices. Quick, reliable, and affordable service guaranteed.</p>
          </div>

          {/* Service Categories */}
          <div className="flex justify-center mb-8">
            <div className="inline-flex h-10 items-center justify-center rounded-md bg-gray-200 p-1 text-gray-700">
              <button 
                onClick={() => setActiveTab('all')} 
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium cursor-pointer hover:bg-primary/10 transition-colors ${activeTab === 'all' ? 'bg-white text-gray-900 shadow-sm' : ''}`}
              >
                All Services
              </button>
              <button 
                onClick={() => setActiveTab('phone')} 
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium cursor-pointer hover:bg-primary/10 transition-colors ${activeTab === 'phone' ? 'bg-white text-gray-900 shadow-sm' : ''}`}
              >
                Phone Repair
              </button>
              <button 
                onClick={() => setActiveTab('computer')} 
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium cursor-pointer hover:bg-primary/10 transition-colors ${activeTab === 'computer' ? 'bg-white text-gray-900 shadow-sm' : ''}`}
              >
                Computer Repair
              </button>
              <button 
                onClick={() => setActiveTab('tablet')} 
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium cursor-pointer hover:bg-primary/10 transition-colors ${activeTab === 'tablet' ? 'bg-white text-gray-900 shadow-sm' : ''}`}
              >
                Tablet Repair
              </button>
              <button 
                onClick={() => setActiveTab('console')} 
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium cursor-pointer hover:bg-primary/10 transition-colors ${activeTab === 'console' ? 'bg-white text-gray-900 shadow-sm' : ''}`}
              >
                Game Console Repair
              </button>
            </div>
          </div>

          {/* Phone Repair Services */}
          <div className={`mb-12 bg-white p-6 rounded-lg shadow-md ${activeTab !== 'all' && activeTab !== 'phone' ? 'hidden' : ''}`}>
            <h3 className="text-2xl font-bold mb-4">Phone Repair Services</h3>
            <p className="text-gray-600 mb-6">Our expert technicians can fix any issue with your smartphone, from cracked screens to battery replacements and water damage repairs.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-lg font-semibold mb-2">Screen Replacement</h4>
                <p className="text-gray-600 mb-2">High-quality replacement screens for all major brands</p>
                <p className="text-primary font-semibold">From $79</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-lg font-semibold mb-2">Battery Replacement</h4>
                <p className="text-gray-600 mb-2">Restore your phone's battery life with genuine replacements</p>
                <p className="text-primary font-semibold">From $49</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-lg font-semibold mb-2">Water Damage Repair</h4>
                <p className="text-gray-600 mb-2">Professional water damage assessment and repair</p>
                <p className="text-primary font-semibold">From $89</p>
              </div>
            </div>
            
            <div className="text-center">
              <Link href="/services/phone-repair" className="inline-block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-primary/90 transition-all">
                View All Phone Repair Services
              </Link>
            </div>
          </div>

          {/* Computer Repair Services */}
          <div className={`mb-12 bg-white p-6 rounded-lg shadow-md ${activeTab !== 'all' && activeTab !== 'computer' ? 'hidden' : ''}`}>
            <h3 className="text-2xl font-bold mb-4">Computer Repair Services</h3>
            <p className="text-gray-600 mb-6">We provide comprehensive computer repair services for all makes and models, from hardware upgrades to software troubleshooting.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-lg font-semibold mb-2">Hardware Upgrades</h4>
                <p className="text-gray-600 mb-2">RAM, SSD, and component upgrades to boost performance</p>
                <p className="text-primary font-semibold">From $89</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-lg font-semibold mb-2">Virus Removal</h4>
                <p className="text-gray-600 mb-2">Complete malware and virus removal with system optimization</p>
                <p className="text-primary font-semibold">From $79</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="text-lg font-semibold mb-2">Data Recovery</h4>
                <p className="text-gray-600 mb-2">Professional recovery of lost or corrupted data</p>
                <p className="text-primary font-semibold">From $129</p>
              </div>
            </div>
            
            <div className="text-center">
              <Link href="/services/computer-repair" className="inline-block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-primary/90 transition-all">
                View All Computer Repair Services
              </Link>
            </div>
          </div>

          {/* Other Services */}
         
            {/* Tablet Repair */}
 <div className={`mb-12 bg-white p-6 rounded-lg shadow-md ${activeTab !== 'all' && activeTab !== 'tablet' ? 'hidden' : ''}`}>
            <h3 className="text-2xl font-bold mb-4">Tablet Repair Services</h3>
            <p className="text-gray-600 mb-6">We provide comprehensive tablet repair services for all makes and models, from screen replacements to battery issues.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="bg-gray-50 p-4 rounded-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/30 to-purple-600/30">
                  <img 
                    src="/src/assets/laptop-screen.png" 
                    alt="Tablet Screen Replacement" 
                    className="w-full h-full object-cover mix-blend-multiply opacity-50"
                  />
                </div>
                <div className="relative z-10">
                  <h4 className="text-lg font-semibold mb-2">Screen Replacement</h4>
                  <p className="text-gray-600 mb-2">High-quality screen replacement for all tablet brands</p>
                  <p className="text-primary font-semibold">From $129</p>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-green-500/30 to-teal-600/30">
                  <img 
                    src="https://images.unsplash.com/photo-1590559821233-37a3d8d3c1e8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    alt="Tablet Battery Replacement" 
                    className="w-full h-full object-cover mix-blend-multiply opacity-50"
                  />
                </div>
                <div className="relative z-10">
                  <h4 className="text-lg font-semibold mb-2">Battery Replacement</h4>
                  <p className="text-gray-600 mb-2">Restore battery life with genuine replacement batteries</p>
                  <p className="text-primary font-semibold">From $89</p>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-500/30 to-red-600/30">
                  <img 
                    src="https://images.unsplash.com/photo-1596458941407-6fb5e89d3157?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    alt="Tablet Charging Port Repair" 
                    className="w-full h-full object-cover mix-blend-multiply opacity-50"
                  />
                </div>
                <div className="relative z-10">
                  <h4 className="text-lg font-semibold mb-2">Charging Port Repair</h4>
                  <p className="text-gray-600 mb-2">Fix charging issues and port damage</p>
                  <p className="text-primary font-semibold">From $79</p>
                </div>
              </div>
            </div>
            
            <div className="text-center">
              <Link href="/services/tablet-repair" className="inline-block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-primary/90 transition-all">
                View All Tablet Repair Services
              </Link>
            </div>
          </div>

          
            
            <div className={`mb-12 bg-white p-6 rounded-lg shadow-md ${activeTab !== 'all' && activeTab !== 'console' ? 'hidden' : ''}`}>
            <h3 className="text-2xl font-bold mb-4">Game Console Repair Services</h3>
            <p className="text-gray-600 mb-6">We provide expert game console repair services for all major gaming systems, from hardware fixes to software issues.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="bg-gray-50 p-4 rounded-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/30 to-blue-600/30">
                  <img 
                    src="https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    alt="HDMI Port Repair" 
                    className="w-full h-full object-cover mix-blend-multiply opacity-50"
                  />
                </div>
                <div className="relative z-10">
                  <h4 className="text-lg font-semibold mb-2">HDMI Port Repair</h4>
                  <p className="text-gray-600 mb-2">Fix display and connectivity issues with HDMI ports</p>
                  <p className="text-primary font-semibold">From $99</p>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/30 to-pink-600/30">
                  <img 
                    src="https://images.unsplash.com/photo-1516841293176-2c1e851c78b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    alt="Disc Drive Replacement" 
                    className="w-full h-full object-cover mix-blend-multiply opacity-50"
                  />
                </div>
                <div className="relative z-10">
                  <h4 className="text-lg font-semibold mb-2">Disc Drive Replacement</h4>
                  <p className="text-gray-600 mb-2">Replace faulty disc drives for all console models</p>
                  <p className="text-primary font-semibold">From $149</p>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-red-500/30 to-orange-600/30">
                  <img 
                    src="https://images.unsplash.com/photo-1605462863863-10d9e47e15ee?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    alt="Overheating Issues" 
                    className="w-full h-full object-cover mix-blend-multiply opacity-50"
                  />
                </div>
                <div className="relative z-10">
                  <h4 className="text-lg font-semibold mb-2">Overheating Issues</h4>
                  <p className="text-gray-600 mb-2">Clean and repair cooling systems to prevent overheating</p>
                  <p className="text-primary font-semibold">From $89</p>
                </div>
              </div>
            </div>
            
            <div className="text-center">
              <Link href="/services/game-console-repair" className="inline-block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-primary/90 transition-all">
                View All Game Console Repair Services
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Detailed Repair Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Detailed Repair Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">We offer professional repair services with quality parts and expert technicians</p>
          </div>
          
          {/* Phone Repair */}
          <div className="mb-16">
            <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
              <div className="md:w-1/2">
                <img 
                  src="https://images.unsplash.com/photo-1591815302525-756a9bcc3425?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                  alt="Phone Repair" 
                  className="rounded-lg shadow-md w-full h-64 object-cover"
                />
              </div>
              <div className="md:w-1/2">
                <h3 className="text-2xl font-bold mb-4">Phone Repair Services</h3>
                <p className="text-gray-600 mb-4">Our expert technicians can fix any issue with your smartphone, from cracked screens to battery replacements and water damage repairs.</p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Screen Replacement</span>
                      <p className="text-sm text-gray-500">High-quality replacement screens for all major brands</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Battery Replacement</span>
                      <p className="text-sm text-gray-500">Restore your phone's battery life with genuine replacements</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Water Damage Repair</span>
                      <p className="text-sm text-gray-500">Professional water damage assessment and repair</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Charging Port Repair</span>
                      <p className="text-sm text-gray-500">Fix charging issues with expert port repairs</p>
                    </div>
                  </li>
                </ul>
                <a href="/services/phone-repair" className="inline-block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-primary/90 transition-all">Learn More</a>
              </div>
            </div>
          </div>
          
          {/* Computer Repair */}
          <div className="mb-16">
            <div className="flex flex-col md:flex-row-reverse items-center gap-8 mb-8">
              <div className="md:w-1/2">
                <img 
                  src="https://images.unsplash.com/photo-1588702547919-26089e690ecc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                  alt="Computer Repair" 
                  className="rounded-lg shadow-md w-full h-auto object-cover"
                />
              </div>
              <div className="md:w-1/2">
                <h3 className="text-2xl font-bold mb-4">Computer Repair Services</h3>
                <p className="text-gray-600 mb-4">We provide comprehensive computer repair services for all makes and models, from hardware upgrades to software troubleshooting.</p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Hardware Upgrades</span>
                      <p className="text-sm text-gray-500">RAM, SSD, and component upgrades to boost performance</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Virus Removal</span>
                      <p className="text-sm text-gray-500">Complete malware and virus removal with system optimization</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Data Recovery</span>
                      <p className="text-sm text-gray-500">Professional recovery of lost or corrupted data</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-solid fa-check text-primary mt-1"></i>
                    <div>
                      <span className="font-semibold">Screen Replacement</span>
                      <p className="text-sm text-gray-500">Laptop screen repairs and replacements</p>
                    </div>
                  </li>
                </ul>
                <a href="/services/computer-repair" className="inline-block bg-primary text-white px-6 py-2 rounded-md font-medium hover:bg-primary/90 transition-all">Learn More</a>
              </div>
            </div>
          </div>
          
          {/* Other Services */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Tablet Repair */}
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm">
              <img 
                src="https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                alt="Tablet Repair" 
                className="rounded-lg shadow-md w-full h-48 object-cover mb-4"
              />
              <div className="flex items-center gap-4 mb-4">
                <div className="text-primary text-3xl">
                  <i className="fas fa-tablet-alt"></i>
                </div>
                <h3 className="text-xl font-bold">Tablet Repair</h3>
              </div>
              <p className="text-gray-600 mb-4">Professional tablet repair services for all major brands including Apple iPad, Samsung Galaxy Tab, and more.</p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Screen replacement</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Battery replacement</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Charging port repair</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Software issues</span>
                </li>
              </ul>
              <a href="/services/tablet-repair" className="text-primary hover:text-primary/90 transition-colors">Learn More →</a>
            </div>
            
            {/* Game Console Repair */}
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm">
              <img 
                src="https://images.unsplash.com/photo-1593305841991-05c297ba4575?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                alt="Game Console Repair" 
                className="rounded-lg shadow-md w-full h-48 object-cover mb-4"
              />
              <div className="flex items-center gap-4 mb-4">
                <div className="text-primary text-3xl">
                  <i className="fas fa-gamepad"></i>
                </div>
                <h3 className="text-xl font-bold">Game Console Repair</h3>
              </div>
              <p className="text-gray-600 mb-4">Expert repair services for PlayStation, Xbox, Nintendo, and other gaming consoles.</p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>HDMI port repair</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Disc drive replacement</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Overheating issues</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-primary"></i>
                  <span>Controller repair</span>
                </li>
              </ul>
              <a href="/services/game-console-repair" className="text-primary hover:text-primary/90 transition-colors">Learn More →</a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Telecom Services Section */}
      <TelecomFeatures />
    </>
  );
};

export default Services;